import { useState } from "react";
import { useParams } from "react-router-dom";

import { TimelineChart } from "../../../../../../components/molecules";
import { useReadBudgetById } from "../../../../../../hooks/react-query/use-read-budget-by-id";
import { updateProfile } from "../../../../../../services/budget";
import { TReadBudgetsResponse } from "../../../../../../services/budget/read-budgets";
import ResourceEditor from "./resource-editor";

export type BudgetProfile = TReadBudgetsResponse["BudgetProfiles"][0];
export type UpdateProfileParams = {
    id_e: string;
    startWeek?: number;
    hoursPerDay?: number;
    efficiencyPercentage?: number;
    additionalCollaborators?: number;
    reductionPercentage?: number;
};

function TimelineSection() {
    const { budgetId } = useParams();

    const { data: budget, refetch } = useReadBudgetById({
        budgetId: budgetId ?? "",
    });
    const budgetProfiles = (budget?.BudgetProfiles ?? []).sort((a, b) => {
        return (b.totals?.totalHours ?? 0) - (a.totals?.totalHours ?? 0);
    });

    const [selectedProfile, setSelectedProfile] =
        useState<BudgetProfile | null>(null);

    const handleProfileSelect = (profile: BudgetProfile) => {
        setSelectedProfile(
            profile.id_e === selectedProfile?.id_e ? null : profile
        );
    };

    const handleProfileUpdate = (updatedProfile: UpdateProfileParams) => {
        updateProfile({
            budgetId: budgetId ?? "",
            profileId: updatedProfile.id_e,
            params: {
                startWeek: updatedProfile.startWeek,
                hoursPerDay: updatedProfile.hoursPerDay,
                efficiencyPercentage: updatedProfile.efficiencyPercentage,
                additionalCollaborators: updatedProfile.additionalCollaborators,
                reductionPercentage: updatedProfile.reductionPercentage,
            },
        }).then(() => {
            refetch();
            setSelectedProfile(null);
        });
    };

    return (
        <>
            <TimelineChart
                profiles={budgetProfiles}
                selectedProfile={selectedProfile}
                onSelectProfile={handleProfileSelect}
            />
            {selectedProfile !== null && (
                <ResourceEditor
                    key={selectedProfile.id_e}
                    profile={selectedProfile}
                    onUpdate={handleProfileUpdate}
                />
            )}
        </>
    );
}

export default TimelineSection;
